function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}

/**
 * Tests value for Promise
 *
 * @function isPromise
 * @param {String} value - Value to be tested
 * @return {Boolean} - Whether value is promise or not
 */
export default function isPromise(value) {
  if (value && _typeof(value) === 'object') {
    return typeof value.then === 'function';
  }
  return false;
}